import React from 'react';
import './YoutubeEmbedVideo.css';

export default function YoutubeEmbedVideo({src}: YoutubeEmbedVideoProps) {
    return (
        <div className={'videobox'}>
            <iframe frameBorder="0" src={src} allowFullScreen={true}/>
        </div>
    )
}

export interface YoutubeEmbedVideoProps {
    src: string;
}